import loginImage from "../Images/side img.svg";
import { Checkbox, TextField } from "@mui/material";
import eyeSlash from "../Images/eye-slash.svg";
import eye from "../Images/eye.svg";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import BaseUrl from "../BaseUrl";
import Context from "../Contex/Context";
import { useContext } from "react";
import { Switch } from "@headlessui/react";
import { useGoogleLogin } from "@react-oauth/google";
import companyLogo from "../../src/Images/coldemail_login.svg";
import googleIcon from "../Images/google icon.svg";
import { Helmet } from "react-helmet";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export default function Login() {
  const { setAuthenticate } = useContext(Context);
  const history = useHistory();
  const [emailStatus, setEmailStatus] = useState({
    clicked: false,
    error: false,
  });
  const [passwordStatus, setPasswordStatus] = useState({
    clicked: false,
    error: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [apiStatus, setApiStatus] = useState({
    status: true,
  });
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [enabled, setEnabled] = useState(true);
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));
  function togglePassword() {
    setShowPassword(!showPassword);
  }
  function isValidEmail(email) {
    // Regular expression pattern for a valid email address
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    return emailPattern.test(email);
  }
  function loginUser() {
    setSpinner(true);
    if (email.length === 0 || !isValidEmail(email)) {
      setEmailStatus({
        clicked: false,
        error: true,
      });
      setSpinner(false);
    } else if (password.length === 0) {
      setPasswordStatus({
        clicked: false,
        error: true,
      });
      setSpinner(false);
    } else {
      let data = {
        username: email,
        password: password,
        remember: enabled,
      };
      axios
        .post(`${BaseUrl.baseurl}/email-marketing/user/login-user`, data)
        .then((res) => {
          setSpinner(false);
          setApiStatus(res.data);
          if (res.data.status) {
            if (res.data.verified) {
              localStorage.setItem(
                "MailSenderuserDetails",
                JSON.stringify(res.data)
              );
              setAuthenticate(true);
              history.push("/Email/accounts");
            } else {
              history.push("/VerifyEmail", res.data.userId);
            }
          }
        })
        .catch((err) => console.log("Error"));
    }
  }

  return (
    <div className="login-parent-container md:grid md:grid-cols-2 md:gap-4">
      <Helmet>
        <title>
          ColdSender.com Login: Access Your Email Outreach Dashboard
        </title>
        <meta
          name="description"
          content="Seamless access to ColdSender.com. Streamline email outreach, elevate your communication. Log in now!"
        />
      </Helmet>
      <div className="hidden md:block">
        <img
          src={loginImage}
          alt=""
          style={{ width: "50vw", height: "100vh", objectFit: "cover" }}
        />
      </div>

      <div className="loginLayout">
        <div
          style={{
            padding: "0px 12px",
            display: "flex",
            flexDirection: "column",
            gap: "7px",
          }}
        >
          <img
            src={companyLogo}
            alt="rocket"
            style={{ height: "40px", marginBottom: "12px" }}
            loading="lazy"
          />
          <div className="social-btn">
            <button
              onClick={() => {
                window.location.href = `${BaseUrl.baseurl}/email-marketing/user/redirect-google-registration`;
              }}
              type="button"
              style={{
                width: "100%",
                outline: "none",
                backgroundColor: "#FFF",
                padding: "6px 16px",
                borderRadius: "4px",
                color: "#434343",
                fontSize: "16px",
                display: "flex",
                gap: "10px",
                alignItems: "center",
                justifyContent: "center",
                boxShadow:
                  "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
              }}
            >
              <img
                src={googleIcon}
                alt="Google Image"
                style={{ height: "25px", width: "20px" }}
                loading="lazy"
              />
              Sign in with Google
            </button>
            <button
              onClick={() => {
                window.location.href = `https://mail.coldsender.com/linkedin/get-linkedin-code`;
              }}
              type="button"
              style={{
                width: "100%",
                outline: "none",
                backgroundColor: "#FFF",
                padding: "6px 16px",
                borderRadius: "4px",
                color: "#434343",
                fontSize: "16px",
                display: "flex",
                gap: "10px",
                alignItems: "center",
                justifyContent: "center",
                boxShadow:
                  "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="25"
                height="25"
                viewBox="0 0 48 48"
              >
                <path
                  fill="#0288D1"
                  d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                ></path>
                <path
                  fill="#FFF"
                  d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                ></path>
              </svg>
              Sign in with LinkedIn
            </button>
          </div>
          <div className="loginTypo">Login</div>
          {!apiStatus.status && (
            <p className="emailpasswrong">{apiStatus.message}!</p>
          )}

          {emailStatus.error && passwordStatus.error && (
            <p className="bothRequiredLayout">
              Email address and password is required!
            </p>
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <p className="loginEmail">Email address</p>
            <TextField
              autoComplete="off"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              onClick={() => {
                setEmailStatus({
                  clicked: true,
                  error: false,
                });
                setPasswordStatus({
                  clicked: false,
                  error: false,
                });
              }}
              // value={searchedVal}
              variant="standard"
              placeholder="Enter your email address"
              InputProps={{
                disableUnderline: true,
                endAdornment: <div style={{ height: "20px" }}></div>,

                sx: {
                  padding: "10px 16px",
                  gap: "10px",
                  fontSize: "15px",
                  width: "100%",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderRadius: "4px",
                  fontWeight: 400,
                  border: emailStatus.clicked
                    ? "1px solid var(--color-secondary, #3471B8)"
                    : emailStatus.error
                    ? "1px solid var(--color-error, #FF3434)"
                    : "1px solid #1C485F",
                  background: "var(--background-color, #FAFAFA)",
                  "& input": {
                    color: "var(--color-dark-500, #868686)",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  },
                },
              }}
            />

            {emailStatus.error && !passwordStatus.error && (
              <p className="emailReq">Enter valid email adress!</p>
            )}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <p className="loginEmail">Password</p>
            <TextField
              autoComplete="off"
              onChange={(e) => setPassword(e.target.value)}
              onClick={() => {
                setPasswordStatus({
                  clicked: true,
                  error: false,
                });
                setEmailStatus({
                  clicked: false,
                  error: false,
                });
              }}
              value={password}
              type={showPassword ? "text" : "password"}
              variant="standard"
              placeholder="Enter your password"
              InputProps={{
                disableUnderline: true,
                endAdornment: showPassword ? (
                  <img
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      togglePassword();
                    }}
                    src={eyeSlash}
                    alt=""
                  />
                ) : (
                  <img
                    onClick={() => {
                      togglePassword();
                    }}
                    src={eye}
                    alt=""
                    style={{ cursor: "pointer" }}
                  />
                ),

                sx: {
                  padding: "10px 16px",
                  gap: "10px",
                  fontSize: "15px",
                  width: "100%",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                  fontWeight: 400,
                  border: passwordStatus.clicked
                    ? "1px solid var(--color-secondary, #3471B8)"
                    : passwordStatus.error
                    ? "1px solid var(--color-error, #FF3434)"
                    : "1px solid #1C485F",
                  background: "var(--background-color, #FAFAFA)",
                  "& input": {
                    color: "var(--color-dark-500, #868686)",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  },
                },
              }}
            />
            {passwordStatus.error && !emailStatus.error && (
              <p className="emailReq">Password is required!</p>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexGrow: 1,
            }}
          >
            <div className="flex items-center">
              <Checkbox
                inputProps={{
                  "aria-labelledby": "controlled",
                }}
                checked={enabled}
                disableRipple
                sx={{
                  color: "#1C485F",
                  "&.Mui-checked": {
                    color: "#1C485F",
                  },
                }}
                onChange={(e) => {
                  setEnabled(e.target.checked);
                }}
              />
              Remember me
            </div>
            <p
              className="forgotLayout"
              onClick={() => {
                history.push("/ForgotPassword");
              }}
            >
              Forgot password?
            </p>
          </div>
          <button
            onClick={() => {
              loginUser();
            }}
            style={{
              width: "100%",
              outline: "none",
              backgroundColor: "#1C485F",
              padding: "10px 16px",
              borderRadius: "4px",
              color: "#FFF",
              fontSize: "14px",
            }}
          >
            {spinner ? (
              <CircularProgress
                style={{
                  color: "var(--color-white, #FFF)",
                  height: "20px",
                  width: "20px",
                }}
              />
            ) : (
              "Login"
            )}
          </button>
          <div className="flex items-center flex-col gap-3">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <p
                style={{
                  fontFamily: "Source Sans 3",
                  color: "#1a1a1a",
                  fontSize: "14px",
                  fontWeight: 400,
                  fontStyle: "normal",
                }}
              >
                Don't have an account?
              </p>
              <p
                onClick={() => {
                  history.push("/SignUp");
                }}
                style={{
                  color: "#3471b8",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontStyle: "normal",
                  marginTop: "0px",
                  cursor: "pointer",
                }}
              >
                Sign up now
              </p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <a
                href="https://coldsender.com/terms-and-conditions/"
                target="_blank"
              >
                Terms and conditions
              </a>{" "}
              |
              <a href="https://coldsender.com/privacy-policy/" target="_blank">
                Privacy policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
